import { all, call, put, takeLatest } from "redux-saga/effects";

import { SET_LOCALE } from "../../actions/controllers/locale";

import { requestTranslations } from "../../actions/translations";
import { requestCalendar } from "../../actions/calendar";
import { fetchAuctions } from "./fetchAuctions";
import { fetchContextMenu } from "./fetchContextMenu";

export function* watchLocale() {
  yield takeLatest(SET_LOCALE, updateLocaleDependants);
}

export function* updateLocaleDependants(action) {
  let locale = action.data;

  // Save locale in cookie
  document.cookie = `locale=${locale}`;

  yield all([
    call(fetchContextMenu, locale),
    call(fetchAuctions, locale),
    put(requestTranslations(locale)),
    put(requestCalendar(locale))
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/onSetLocale.js